import Seven from './7shifts'

export default [
  { path: '/enterprise/integration/7shifts', component: Seven, meta: { auth: true } },
]